import { getMomentDate } from '../utils/commonUtils';
import BaseModel from './BaseModel';
import { SUPPLIER } from '../constants/Define';
export default class SupplierCategory extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
        this.code = data.code || undefined;
        this.description = data.description || undefined;
        this.setCategoryKeys(data);
    }

    setCategoryKeys(data = {}) {
        this.categoryKeys = (data.categoryKeys || []).map(item => new CategoryKeys(item));
    }

    setLogo(url, name) {
        this.logo = url;
    }

    removeLogo(url) {
        this.logo = undefined;
    }

    export(hasTranslate = false) {
        const result = {
            id: this.id,
            name: this.name,
            code: this.code,
            description: this.description,
            categoryKeys: this.categoryKeys ? (this.categoryKeys || []).map(item => new CategoryKeys(item)) : [],
        }
        return result;
    }

}

export class CategoryKeys extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
        this.code = data.code || undefined;
        this.type = data.type || 0;
    }

    export(hasTranslate = false) {
        return {
            id: this.id,
            name: this.name,
            code: this.code,
            type: this.type || 0,
        }
    }
}